Header.$inject = ['userServer', '$state', 'userProfile']
function Header(userServer, $state, userProfile){
  var vm = this

  vm.profile = null
  vm.logout = logout
  vm.userProfile = userProfile

  function logout(){
    userServer.logout()
      .then(function(){
        $state.go('login')
      })
  }

  userServer.profile()
    .then(function(result){
      vm.profile = result
    })
}

export default Header